<template>
  <div class="discount-detail__content" v-if="discount.customData">
    <img :src="discount.image_url" :alt="discount.title">
    <p class="my-4">{{ discount.customData.description }}</p>
    <div class="details d-flex align-items-end">
      <h4 class="date">{{ timeFormat(discount.date) }}</h4>
      <div class="price ml-auto">
        <h3
          class="price-from d-inline"
          v-if="discount.customData.price"
        >
          {{ priceFormat(discount.customData.price.old) }}
        </h3>
        <h2
          class="price-to d-inline px-2"
          :class="'color-' + discount.branche"
          v-if="discount.customData.price"
        >
          {{ priceFormat(discount.customData.price.new) }}
        </h2>
      </div>
    </div>

  </div>
</template>

<script>
import Formatting from '@/mixins/Formatting'

export default {
  name: 'DiscountCustom',
  mixins: [Formatting],
  props: {
    discount: Object
  }
}
</script>
